export default {
  en: {
      home: "Home",
      devlog: "WELCOME",
      greeting: "Hi, I'm Alan",
      nickname: "aka Kuni",
      bio: "DevArtist / 3D Generalist - Modeler & Animator<br/>Character Designer | Props | Arq | Environments<br/>Blender, Unreal, Adobe, Cinema4D <br/> Html/Css/Js ⇒ Learning React (Stack: MERN)",
      portfolio: "Portfolio",

      entry1_title: "PANCAKE BUNNY GAME",
      entry1_desc: "I led a team of three people to develop a mini game in five days at the Women Games Jam...",
      entry1_tags: ['videojuegos'],

      entry2_title: "FIGHTER",
      entry2_desc: "Sculpt, Retopology, Rigging, Animation, Render",
      entry2_tags: ['modelado', 'animacion'],

      entry3_title: "NEXT PROJECT",
      entry3_desc: "Developing a web-based video game as a SoloDev using Three.js...",
      entry3_tags: ['videojuegos'],

      entry4_title: "GOOSE FOOTBALL GAME IN 6 DAYS",
      entry4_desc: "How did I manage to write over a thousand lines of code to create a unique video game? By blending creativity, technical skills, and the power of artificial intelligence as my ally...",
      entry4_tags: ['videojuegos'],

      entry5_title: "AI FOR 3D ANIMATION",
      entry5_desc: "How to create captivating 3D animations with the help of artificial intelligence? ¿Ai tracking or Stable Diffusion?",
      entry5_tags: ['modelado', 'animacion'],

      entry6_title: "AI FOR 3D MODELS AND CONCEPTS",
      entry6_desc: "How do I draw inspiration from AI-generated 3D models to craft my own unique creations?",
      entry6_tags: ['modelado'],

      entry7_title: "PROCEDURAL TEXTURES",
      entry7_desc: "I believe procedural techniques are the future—whether for textures or environments. The users can experience deeper immersion and feel like they’re in a truly unique world...",
      entry7_tags: ['arquitectura'],

      entry8_title: "METAHUMANS",
      entry8_desc: "My workflow for putting Metahumans into Blender...",
      entry8_tags: ['modelado'],

      entry9_title: "RAZE FROM VALORANT",
      entry9_desc: "Based on stickers from the Riot Games game.",
      entry9_tags: ['modelado', 'animacion'],

      entry10_title: "MOTION GRAPHICS TECHNIQUES",
      entry10_desc: "A deep dive into MG techniques for abstract animations...",
      entry10_tags: ['motion graphics'],

      entry11_title: "Game: Ferapets",
      entry11_desc: "More content soon...",

      entry12_title: "AI-GENERATED TEXTURES",
      entry12_desc: "Using AI tools to generate high-quality textures for 3D models...",

      entry13_title: "SOME STUFF OF ARCHITECTURE",
      entry13_desc: "soon...",
      entry13_tags: ['arquitectura'],


      entry14_title: "My experience at Doopler Studio",
      entry14_desc: "3D Billboards for multinationals companies...",

      entry15_title: "MOTION CAPTURE INTEGRATION",
      entry15_desc: "Integrating motion capture data into 3D animations for realistic movements...",

      entry16_title: "PARTICLE EFFECTS IN GAMES",
      entry16_desc: "Creating stunning particle effects to enhance visual appeal in games...",
      entry17_title: "SHADER PROGRAMMING",
      entry17_desc: "Writing custom shaders to achieve unique visual effects in real-time rendering...",

      entry18_title: "HOW I LEARNED TO USE GITHUB, CMD & JS",
      entry18_desc: "Thanks to iA and tireless practice, I feel confident in web development. Every idea generated a problem, and for every problem I sought a solution...",

      claireanim01: "The animation of this character was rendered with iA, from a frame that I previously rendered with Blender. The character design came entirely from my head, haha, there was no concept art that I based it on, and I want to emphasize that, because, at least for me, it was always difficult to convey an idea that only existed in my imagination. Both on paper, drawing, and in 3D :)",
      claireanim02: "The following techniques will be tested with Cascadeur, Rokoko, or similar software.",

      bot_desc01: "The models made by iA are very poorly optimized. They have blurry textures and noticeable errors. But even so, they unleash creativity.",
      bot_desc02: "Preview the 3D model.",

    },
    es: {
      home: "Inicio",
      devlog: "BIENVENIDOS",
      greeting: "Hola, soy Alan",
      nickname: "aka Kuni",
      bio: "DevArtist / Generalista 3D - Modelador & Animador<br/>Diseño Personajes | Props | Arq | Environments<br/>Blender, Unreal, Adobe, Cinema4D <br/> Html/Css/Js ⇒ Aprendiendo React (Stack: MERN)",
      portfolio: "Portafolio",

      entry1_title: "PANCAKE BUNNY",
      entry1_desc: "Lideré un equipo de 3 personas para llevar a cabo un mini juego en 5 días, en la Women Games Jam...",
      entry1_tags: ['videojuegos'],


      entry2_title: "LUCHADOR",
      entry2_desc: "Escultura, Retopología, Rigging, Animación, Render.",
      entry2_tags: ['modelado', 'animacion'],

      entry3_title: "PRÓXIMO PROYECTO",
      entry3_desc: "Desarrollando como SoloDev un videojuego para web con Three.js...",
      entry3_tags: ['videojuegos'],

      entry4_title: "FÚTBOL DE GANSOS EN 6 DÍAS",
      entry4_desc: "¿Cómo logré escribir más de mil líneas de código para crear un videojuego único? Combinando creatividad, habilidades técnicas y el poder de la inteligencia artificial como mi aliada...",
      entry4_tags: ['videojuegos'],

      entry5_title: "IA PARA ANIMACIÓN 3D",
      entry5_desc: "¿Cómo crear animaciones 3D con la ayuda de la inteligencia artificial? ¿iA tracking o Stable Diffusion?",
      entry5_tags: ['modelado', 'animacion'],

      entry6_title: "IA PARA MODELOS Y CONCEPTOS 3D",
      entry6_desc: "¿Cómo me inspiro en modelos 3D generados por IA para crear mis propias creaciones únicas?",
      entry6_tags: ['modelado'],

      entry7_title: "TEXTURAS PROCEDURALES",
      entry7_desc: "Creo que las técnicas procedurales son el futuro, ya sea para texturas, animación o ambientes. Los usuarios podrían experimentar una inmersión más profunda y sentir que están en un mundo verdaderamente único...",
      entry7_tags: ['arquitectura'],

      entry8_title: "METAHUMANS",
      entry8_desc: "Mi workflow para colocar Metahumans en Blender...",
      entry8_tags: ['modelado'],

      entry9_title: "RAZE DE VALORANT",
      entry9_desc: "Basada en los stickers del juego de Riot Games.",
      entry9_tags: ['modelado', 'animacion'],

      entry10_title: "MOTION GRAPHICS TECNICAS",
      entry10_desc: "Un análisis a las técnicas de animaciones abstractas...",
      entry10_tags: ['motion graphics'],

      entry11_title: "Juego: Ferapets",
      entry11_desc: "Pronto más contenido...",

      entry12_title: "TEXTURAS GENERADAS POR IA",
      entry12_desc: "Algunas texturas creadas por mi y otras por IA para descargar, prrrronto...",

      entry13_title: "ALGUNAS COSAS DE ARQUITECTURA",
      entry13_desc: "Pronto subiré el contenido...",
      entry13_tags: ['arquitectura'],

      entry14_title: "3D Billboards",
      entry14_desc: "Mi experiencia en Doopler Studio y sus clientes multinacionales...",

      entry15_title: "INTEGRACIÓN DE CAPTURA DE MOVIMIENTO",
      entry15_desc: "Integrando datos de captura de movimiento en animaciones 3D para movimientos realistas...",

      entry16_title: "PRONTO",
      entry16_desc: "Pronto más contenido...",
      entry17_title: "PRONTO",
      entry17_desc: "Pronto más contenido...",

      entry18_title: "COMO CONOCÍ GITHUB, EL CMD y JAVASCRIPT",
      entry18_desc: "Gracias a la iA y con una práctica incansable, siento una dominación en el Desarrollo Web. Cada idea generaba un problema, y a cada problema buscaba la solución...",

      claireanim01: "La animación de este personaje fue renderizada con iA, de un frame que previamente rendericé con Blender. El diseño del personaje fue sacado totalmente de mi cabeza jaja, no hubo ningún concept art en el que me basara , y quiero recalcar eso, porque, por lo menos a mi siempre me costó transmitir una idea que solo vagaba en mi imaginación. Tanto en papel, dibujando. Como en 3D :)",
      claireanim02: "Las siguientes técnicas a probar serán con Cascadeur, Rokoko o similar.",

      bot_desc01: "Los modelos hechos por iA están muy mal optimizados. \nCon texturas borrosas y errores notables. Pero aún así libera la creativdad.",
      bot_desc02: "Previsualiza el modelo 3D",

  }
};
